import React from 'react';
import { Card, Table } from 'antd';

export default function CommonCard(props) {
  
  const { title, extra, columns, style, dataSource, ...over  } = props;

  return (
    <Card title={title} extra={extra} style={style}>
      <Table 
        columns={columns}
        dataSource={dataSource}
        {...over}
      />
    </Card>
  )
}
